if (!window._babelPolyfill) {
  require('babel-polyfill');
}

import 'tippy.js/dist/tippy.css';
import React from 'react'

import sha256 from 'js-sha256';

import '@fortawesome/fontawesome-free/css/all.css';
import { render } from 'react-dom'

import Vue from 'vue';
import InstantSearch from 'vue-instantsearch';
import PortalVue from 'portal-vue';

import { setupSentry } from '../shared/sentry';
import store from '../shared/store';
import './directives';
import { renderAutoInjectableComponents } from './components';
import './snippets';
import { createInertiaApp } from '@inertiajs/inertia-react'

setupSentry(Vue);

Vue.use(InstantSearch);
Vue.use(PortalVue);

new Vue({ el: '#app', store });
new Vue({ el: '#header-app', store });

createInertiaApp({
  id: 'inertia_root',
  resolve: name => require(`./pages/${name}`),
  setup({ el, App, props }) {
    render(<App {...props} />, el)
  },
})
 // This must be done after VueJS is done mounting, so that it doesn't mess
// with what React has rendered (doing it before results in non-functional
// event handlers, which is annoying)
renderAutoInjectableComponents();
